export const pageTitle = (title) => {
  return ( document.title = title + " - CSE TMSL");
}